import React, {useState} from 'react';
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import Card from "@mui/material/Card";
import { Grid } from "@mui/material";
import MDSnackbar from "components/MDSnackbar";
import MDButton from "components/MDButton";
import InterventionTable from './table/interventionTable';
import useIntervention from "./table/useIntervention";
import { downloadCsv, downloadJson } from "../utils/exportData";


const ShowInterventionList = () => {
        const { data: interventionsData = [], loading: exportLoading } = useIntervention("export");

        const [successSB, setSuccessSB] = useState(false);
        const [errorSB, setErrorSB] = useState(false);
        const openSuccessSB = () => setSuccessSB(true);
        const closeSuccessSB = () => setSuccessSB(false);
        const openErrorSB = () => setErrorSB(true);
        const closeErrorSB = () => setErrorSB(false);

        function bringSuccessNotification(){
            return (
                <MDSnackbar
                  color="success"
                  icon="check"
                  title="Succefully Deleted"
                  content="Your alert has been deleted"
                  dateTime={new Date().toLocaleTimeString()}
                  open={successSB}
                  onClose={closeSuccessSB}
                  close={closeSuccessSB}
                  bgWhite
                />
              );
        }
    
        function bringErrorNotification(){  
            return (
                <MDSnackbar
                  color="error"
                  icon="warning"
                  title="Error on deleting"
                  content="Your alert has not been deleted"
                  dateTime={new Date().toLocaleTimeString()}
                  open={errorSB}
                  onClose={closeErrorSB}
                  close={closeErrorSB}
                  bgWhite
                />
              );
        }


    return (
        <DashboardLayout>
            <Card style={{ marginTop: '3px', padding: '12px', height: '100%' }}>
                <Grid container item xs={12} md={12}>
                    <Grid item xs={12} md={12}>
                        <div className='rawContainerDiagrams'>
                            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: "12px", marginBottom: "12px", flexWrap: "wrap" }}>
                            <div className='diagrammHeadTitle' style={{color:"white"}}>Λίστα Παρεμβάσεων</div>
                                <div style={{ display: "flex", gap: "8px", flexWrap: "wrap" }}>
                                    <MDButton
                                      variant="outlined"
                                      color="info"
                                      disabled={exportLoading || interventionsData.length === 0}
                                      onClick={() => downloadCsv(interventionsData, "interventions")}
                                      sx={{ "&.MuiButton-root": { textTransform: "none" } }}
                                    >
                                      Download CSV
                                    </MDButton>
                                    <MDButton
                                      variant="contained"
                                      color="info"
                                      disabled={exportLoading || interventionsData.length === 0}
                                      onClick={() => downloadJson(interventionsData, "interventions")}
                                      sx={{ "&.MuiButton-root": { textTransform: "none" } }}
                                    >
                                      Download JSON
                                    </MDButton>
                                </div>
                            </div>
                            <InterventionTable setSuccessSB={setSuccessSB} setErrorSB={setErrorSB}  />
                        </div>
                    </Grid>
                </Grid>
            </Card>
            {successSB && bringSuccessNotification()}
            {errorSB && bringErrorNotification()}
        </DashboardLayout>
    );
};

export default ShowInterventionList;
